import { useCallback, useEffect, useState } from 'react';
import { getAssetIssues } from 'services/locations';
import { AssetIssues } from 'types/room';

export const useGetOptionAssetIssues = (roomId?: number) => {
  const [optionAssetSelect, setOptionAssetSelect] = useState<AssetIssues[]>([]);

  const handleGetInitOptionFileAsset = useCallback(async () => {
    if (!roomId) return;
    const dataAsset = await getAssetIssues({
      page: 1,
      size: 1000,
      roomId: roomId.toString()
    });

    setOptionAssetSelect(dataAsset?.submittedAssets);
  }, [roomId]);

  useEffect(() => {
    handleGetInitOptionFileAsset();
  }, [handleGetInitOptionFileAsset]);

  return { optionAssetSelect, handleGetInitOptionFileAsset };
};
